<template>
  <div>

    <b-card
        v-if="settings_PhotoDisplay=== 'full'"
        overlay
        :img-src="photoImgURL"
        :img-alt="`Cover for ${photo.title}`"
        text-variant="white"
        :title="photo.title"
        title-tag="h2"
        sub-title-tag="h4"
        sub-title-text-variant="light"
        body-text-variant="black"
    >
      <template
          v-if="settings_ShowAddedBy && hasCreatedBy"
          cols="6"
      >
        <b-card-text>
          <b-row v-if="hasCreatedBy && settings_ShowAddedBy">
            <b-col cols="2">
              <b-img
                  v-bind="mainProps"
                  :src="createdByImgURL"
                  rounded="circle"
                  alt="Circle image"
                  left
              />
              <b-icon-soundwave
                  v-if="createdByAudio"
                  :variant="createdByAudio ? 'warning': 'secondary'"
                  font-scale="5"
                  @click="handlePlayAudio(createdByAudio)"
                  style="cursor:pointer;"
              />
            </b-col>
            <b-col cols="8">
              added by {{createdByName}}  {{photo._created_at && false ?
                `on ${photo._created_at}`:''}}
            </b-col>
          </b-row>
        </b-card-text>

      </template>
    </b-card>
    <b-card v-else
            no-body
            class="overflow-hidden photo-card"
    >
      <b-row >
        <b-col md="9">
          <b-card-img-lazy
            :src="photoImgURL"
            alt="Image"
            class="rounded-0 profile-bg"
          ></b-card-img-lazy>
          <b-icon-soundwave
              v-if="photoAudio"
              :variant="photoAudio ? 'warning': 'secondary'"
              class="photo-sound-btn"
              font-scale="3"
              @click="handlePlayAudio(photoAudio)"
              style="cursor:pointer"
          />
        </b-col>
        <b-col md="3">
          <b-card-body>
            <b-row>
              <b-col>
                <h4>{{ photo.title ? photo.title : 'No Title' }}</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <tip-tap-output
                    v-if="photo.description"
                    :content="photo.description" />
                    <h6 v-else>
                      {{ 'No Details. Please add.' }}
                    </h6>
              </b-col>
            </b-row>
            <b-row v-if="hasCreatedBy && settings_ShowAddedBy">
              <b-col cols="2">
                <b-img
                    v-bind="mainProps"
                    :src="createdByImgURL"
                    rounded="circle"
                    alt="Circle image"
                    left
                />
                <b-icon-soundwave
                    v-if="createdByAudio"
                    :variant="createdByAudio ? 'warning': 'secondary'"
                    font-scale="5"
                    @click="handlePlayAudio(createdByAudio)"
                    style="cursor:pointer;"
                />
             </b-col>
              <b-col cols="8">
                added by {{createdByName}}  {{photo._created_at && false ?
                  `on ${photo._created_at}`:''}}
              </b-col>
            </b-row>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import moment from "moment";
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  name: "PhotoAlbum_PhotoCard",
  components: {TipTapOutput},
  props: {
    photo: {
      type: Object,
      default: () => {}
    },
    assetsUrlHome: {
      type: String,
      default: ""
    },
    settings_PhotoDisplay: {
      type: String,
      default: ""
    },
    settings_ShowAddedBy: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    photoImgURL() {
      return this.photo.imgURL
        ? `${this.assetsUrlHome}${this.photo.imgURL}`
        : "";
    },
    iconImgProps() {
      if (this.photo.imgURL) {
        this.mainProps.src = `${this.assetsUrlHome}${this.photo.imgURL}`;
      }
      return this.mainProps;
    },
    photoAudio(){
      return this.photo && this.photo.audio && this.photo.audio.audioURL
          ? this.photo.audio.audioURL: false;
    },
    hasCreatedBy() {
      return Object(this.photo).hasOwnProperty("_created_by");
    },
    createdByName() {
      return this.hasCreatedBy ? this.photo._created_by.name : "";
    },
    createdByRelation() {
      return this.hasCreatedBy ? this.photo._created_by.relation : "";
    },
    createdByImgURL() {
      return this.hasCreatedBy ? this.photo._created_by.imgURL : "";
    },
    createdByAudio() {
      return this.hasCreatedBy && this.photo._created_by.audio &&  this.photo._created_by.audio.audioURL ?
          this.photo._created_by.audio.audioURL : false;
     // return `${this.assetsURLPath}audio/createdbyaudio.mp3`;
    },
    createdAtDate() {
      return 'true';
      return  this.photo && this.photo._created_at ?
          this.formatDate(this.photo._created_at) : null;
    }
  },
  methods:{
    formatDate(date) {
      return 'wrong'
    },
    formattedDate(date) {
      //@TODo - Date format should be standardized even for apps
      return moment(new Date(date.toDate())).format("dddd, DD MMMM YYYY");
    },
    handlePlayAudio(audioURL){
      this.player = new Audio(audioURL);
      let that = this; // Check that there are no issues with this
      this.player.addEventListener("ended", function() {
          that.player.pause();
      });
      //this.audioDuration = this.getDuration(this.player.duration);
      if (this.player) {
        this.player.play();
      }
    }
  },
  data() {
    return { //https://heartbeatfam.com/assets/apps/photoalbum/audio/maryb.mp3
      assetsURLPath:'/assets/apps/photoalbum/',
      player:null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.photo-card {
  width: 100%;
  //   height: 357px;
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
  border-radius: 8px !important;
  background: #ffffff;
  position: relative;
  font-family: "Nunito", sans-serif;
  .photo-bg {
    width: 100%;
    background: rgba(184, 136, 92, 0.1);
    background-color: #ddbc9e;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
    background-repeat: repeat-x;
  }
  .photo-sound-btn {
    position: absolute;
    left: 0%;
    top: 85%;
    text-align: left;
    background-color: rgba(10, 9, 9, 0.7);
    color: #272f75;
    font-weight: bold;
    cursor: pointer;
    height: 55px;
    width: 135px;
    font-size: 12px;
  }
}
</style>
